/** Lowercase, hyphenated, ascii-ish slug used as the discipline key for the work library. */
export function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Stable discipline key from an org-unit name; null = Common (all disciplines). */
export function disciplineKeyOf(orgUnitName: string | undefined | null): string | null {
  if (!orgUnitName) return null;
  const slug = slugify(orgUnitName);
  return slug || null;
}
